module.exports = __webpack_public_path__ + "img/title.5b351181.jpg";